export default class GroupedValidator {
	private readonly validator: Function;
	private readonly group: string;
	private readonly message: string = '';
	private readonly fields: string[];

	/**
	 * Constructs the class
	 *
	 * @param {Function} validator The validator being grouped.
	 * @param {string[]} fields The fields the validator is being applied to.
	 * @param {string} group The group's name.
	 * @param {string} message The validation message to throw if the group is invalid.
	 */
	constructor( validator: Function, fields: string[], group: string, message?: string ) {
		this.fields = fields;
		this.validator = validator;
		this.group = group;
		this.message = message;
	}

	/**
	 * Gets the validator function.
	 *
	 * @returns {Function} The validator.
	 */
	getValidator(): Function {
		return this.validator;
	}

	/**
	 * Gets the group name.
	 *
	 * @returns {string} The group's name.
	 */
	getGroup(): string {
		return this.group;
	}

	/**
	 * Gets group's message.
	 *
	 * @returns {string} The message to throw.
	 */
	getMessage(): string {
		return this.message;
	}

	/**
	 * Gets the fields to apply the validator to.
	 *
	 * @returns {string[]} The fields the validator needs to be applied to.
	 */
	getFields(): string[] {
		return this.fields;
	}
}
